/**
 * Farmer Site — theme presets.
 *
 * A theme is PRESENTATION ONLY (colors, typography, layout tokens).
 * It never touches content. Switching themes just swaps the tokens
 * below on the site root.
 */
export const THEMES = {
  "farm-market": {
    id: "farm-market",
    name: "Farm Market",
    family: "commerce-first",
    tokens: {
      "--fs-brand": "#F97316",
      "--fs-brand-ink": "#7A3300",
      "--fs-accent": "#166534",
      "--fs-bg": "#FDF9F0",
      "--fs-panel": "#FFFFFF",
      "--fs-ink": "#151312",
      "--fs-muted": "#3A3830",
      "--fs-hairline": "rgba(0,0,0,0.10)",
      "--fs-shadow": "0 10px 30px rgba(0,0,0,0.08)",
    },
    fonts: { display: `"DM Serif Display", "Cormorant Garamond", serif`,
             body: `"Inter", "Segoe UI", -apple-system, sans-serif` },
    layout: { hero: "asymmetric", productCols: 4, journalCols: 3 },
  },
  "fresh-harvest": {
    id: "fresh-harvest",
    name: "Fresh Harvest",
    family: "family-first",
    tokens: {
      "--fs-brand": "#16A34A",
      "--fs-brand-ink": "#0B4A22",
      "--fs-accent": "#B45309",
      "--fs-bg": "#F7F5EF",
      "--fs-panel": "#FFFFFF",
      "--fs-ink": "#1F2A21",
      "--fs-muted": "#7B8271",
      "--fs-hairline": "rgba(15,54,26,0.14)",
      "--fs-shadow": "0 12px 32px rgba(11,74,34,0.10)",
    },
    fonts: { display: `"Caveat", "DM Serif Display", cursive`,
             body: `"Inter", "Segoe UI", -apple-system, sans-serif` },
    layout: { hero: "centered", productCols: 3, journalCols: 3 },
  },
  "pine-hollow": {
    id: "pine-hollow",
    name: "Pine Hollow",
    family: "country-store",
    tokens: {
      "--fs-brand": "#3F6837",
      "--fs-brand-ink": "#22391D",
      "--fs-accent": "#8B5A2B",
      "--fs-bg": "#F1E6CE",
      "--fs-panel": "#FFF9EA",
      "--fs-ink": "#2A1E10",
      "--fs-muted": "#7A6B54",
      "--fs-hairline": "rgba(60,42,20,0.18)",
      "--fs-shadow": "0 10px 28px rgba(60,42,20,0.12)",
    },
    fonts: {
      display: `"Cormorant Garamond", "DM Serif Display", serif`,
      body: `"Inter", "Segoe UI", -apple-system, sans-serif`,
    },
    layout: { hero: "asymmetric", productCols: 4, journalCols: 3 },
  },
  "greenfield": {
    id: "greenfield",
    name: "Greenfield Farm",
    family: "forest-first",
    tokens: {
      "--fs-brand": "#2F5D2F",
      "--fs-brand-ink": "#153015",
      "--fs-accent": "#B79766",
      "--fs-bg": "#F3EEDE",
      "--fs-panel": "#FBF7EA",
      "--fs-ink": "#1B2A1B",
      "--fs-muted": "#6B7B6B",
      "--fs-hairline": "rgba(27,42,27,0.14)",
      "--fs-shadow": "0 12px 30px rgba(27,42,27,0.10)",
    },
    fonts: {
      display: `"DM Serif Display", "Cormorant Garamond", serif`,
      body: `"Inter", "Segoe UI", -apple-system, sans-serif`,
    },
    layout: { hero: "asymmetric", productCols: 3, journalCols: 3 },
  },
  "ocean-fresh": {
    id: "ocean-fresh",
    name: "Ocean Fresh",
    family: "seafood-first",
    tokens: {
      "--fs-brand": "#1E3D5B",
      "--fs-brand-ink": "#0F2138",
      "--fs-accent": "#3A9AC7",
      "--fs-bg": "#EFE7D6",
      "--fs-panel": "#FBF6E8",
      "--fs-ink": "#0F2138",
      "--fs-muted": "#5B6A7C",
      "--fs-hairline": "rgba(15,33,56,0.16)",
      "--fs-shadow": "0 10px 26px rgba(15,33,56,0.14)",
    },
    fonts: {
      display: `"DM Serif Display", "Cormorant Garamond", serif`,
      body: `"Inter", "Segoe UI", -apple-system, sans-serif`,
    },
    layout: { hero: "asymmetric", productCols: 3, journalCols: 3 },
  },
  "greenhorizon": {
    id: "greenhorizon",
    name: "GreenHorizon",
    family: "modern-farm",
    tokens: {
      "--fs-brand": "#2E8B4A",
      "--fs-brand-ink": "#175027",
      "--fs-accent": "#1F5E33",
      "--fs-bg": "#F7FBF6",
      "--fs-panel": "#FFFFFF",
      "--fs-ink": "#153020",
      "--fs-muted": "#6B7A70",
      "--fs-hairline": "rgba(21,48,32,0.10)",
      "--fs-shadow": "0 10px 30px rgba(21,48,32,0.08)",
    },
    fonts: {
      display: `"DM Serif Display", "Inter", sans-serif`,
      body: `"Inter", "Segoe UI", -apple-system, sans-serif`,
    },
    layout: { hero: "asymmetric", productCols: 4, journalCols: 3 },
  },
  "meadow-lane": {
    id: "meadow-lane",
    name: "Meadow Lane",
    family: "photo-first",
    tokens: {
      "--fs-brand": "#3E5C33",
      "--fs-brand-ink": "#1F3016",
      "--fs-accent": "#B08D57",
      "--fs-bg": "#F1EBDC",
      "--fs-panel": "#FBF6E7",
      "--fs-ink": "#1F2318",
      "--fs-muted": "#7C7562",
      "--fs-hairline": "rgba(31,48,22,0.16)",
      "--fs-shadow": "0 12px 30px rgba(31,48,22,0.14)",
    },
    fonts: {
      display: `"Cormorant Garamond", "DM Serif Display", serif`,
      body: `"Inter", "Segoe UI", -apple-system, sans-serif`,
    },
    layout: { hero: "asymmetric", productCols: 3, journalCols: 4 },
  },
  "green-harvest": {
    id: "green-harvest",
    name: "Green Harvest Cart",
    family: "produce-cart",
    tokens: {
      "--fs-brand": "#2E7D32",
      "--fs-brand-ink": "#1B4B1E",
      "--fs-accent": "#F57C00",
      "--fs-bg": "#F2F7EE",
      "--fs-panel": "#FFFFFF",
      "--fs-ink": "#1F2A1B",
      "--fs-muted": "#6B7A65",
      "--fs-hairline": "rgba(31,42,27,0.12)",
      "--fs-shadow": "0 10px 26px rgba(31,74,30,0.10)",
    },
    fonts: {
      display: `"DM Serif Display", "Cormorant Garamond", serif`,
      body: `"Inter", "Segoe UI", -apple-system, sans-serif`,
    },
    layout: { hero: "asymmetric", productCols: 4, journalCols: 3 },
  },
};

/**
 * Apply a theme's tokens to a container ref (fallback: document root).
 * `overrides` (from `site.theme_overrides`) can layer custom colors
 * (brand/accent/bg/ink/…) over the base theme without changing content.
 */
export function themeVars(themeId, overrides = null) {
  const t = THEMES[themeId] || THEMES["farm-market"];
  const base = {
    ...t.tokens,
    fontFamily: t.fonts.body,
    "--fs-display": t.fonts.display,
  };
  if (!overrides || typeof overrides !== "object") return base;
  // Accept either shape {tokens:{--fs-brand:...}} or flat {brand:"#…"}
  const flat = {};
  const map = { brand: "--fs-brand", brandInk: "--fs-brand-ink", accent: "--fs-accent",
                bg: "--fs-bg", panel: "--fs-panel", ink: "--fs-ink", muted: "--fs-muted" };
  for (const [k, v] of Object.entries(overrides)) {
    if (!v) continue;
    if (k === "tokens" && typeof v === "object") Object.assign(flat, v);
    else if (map[k]) flat[map[k]] = v;
    else if (k.startsWith("--fs-")) flat[k] = v;
  }
  return { ...base, ...flat };
}

export function themeById(themeId) {
  return THEMES[themeId] || THEMES["farm-market"];
}

/** Fallback theme when a website's chosen theme isn't rendered live yet. */
export const FALLBACK_THEME = "farm-market";
